// frontend/src/components/games/tetris/TetrisControls.tsx

interface TetrisControlsProps {
  onLeft: () => void;
  onRight: () => void;
  onRotate: () => void;
  onSoftDrop: () => void;
  onHardDrop: () => void;
}

export function TetrisControls({ onLeft, onRight, onRotate, onSoftDrop, onHardDrop }: TetrisControlsProps) {
  return (
    <div className="tetris-controls" role="group" aria-label="Tetris kontrolleri">
      <button type="button" className="tetris-control-btn" onClick={onLeft} aria-label="Sol">◀</button>
      <button type="button" className="tetris-control-btn" onClick={onRotate} aria-label="Döndür">🔄</button>
      <button type="button" className="tetris-control-btn" onClick={onRight} aria-label="Sağ">▶</button>
      <button type="button" className="tetris-control-btn" onClick={onSoftDrop} aria-label="Yavaş Düşür">▼</button>
      <button type="button" className="tetris-control-btn wide" onClick={onHardDrop} aria-label="Hızlı Düşür">⬇ Bırak</button>
    </div>
  );
}
